import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../lib/brand";

export const WhatsAppFAB = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-110 active:scale-95 transition-transform"
  >
    <MessageCircle className="h-6 w-6" />
    <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-white animate-ping" />
  </a>
);

export default WhatsAppFAB;
